import React from 'react';
import styled from 'styled-components';
import { VideoPlayer } from './VideoPlayer';
import { VideoInfo } from './VideoInfo';

interface Credit {
    name: string;
    role: string;
}

interface VideoSectionProps {
    videoSrc: string;
    videoPoster?: string;
    videoTitle: string;
    videoDescription: string;
    credits: Credit[];
    videoPosition: 'left' | 'right';
    backgroundColor: string;
}

const SectionWrapper = styled.div<{ $backgroundColor: string }>`
    background-color: ${({ $backgroundColor }) => $backgroundColor};
    display: flex;
    justify-content: center;
    width: 100%;
`;

const SectionContainer = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 0;
    width: 100%;
    max-width: 1800px;

    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        grid-template-columns: 1fr;
    }
`;

const VideoSide = styled.div<{ $position: 'left' | 'right' }>`
    order: ${({ $position }) => ($position === 'left' ? 1 : 2)};
    padding: ${({ theme }) => theme.spacing.xxl};
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    z-index: 20;

    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        order: 1;
        padding: ${({ theme }) => theme.spacing.xl} ${({ theme }) => theme.spacing.md};
    }
`;

const InfoSide = styled.div<{ $position: 'left' | 'right' }>`
    order: ${({ $position }) => ($position === 'left' ? 2 : 1)};
    padding: ${({ theme }) => theme.spacing.xxl};
    display: flex;
    align-items: center;
    justify-content: center;

    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        order: 2;
        padding: ${({ theme }) => theme.spacing.xl} ${({ theme }) => theme.spacing.md};
    }
`;

const VideoWrapper = styled.div`
    width: 100%;
`;

const InfoWrapper = styled.div`
    max-width: 600px;
    width: 100%;
`;

export const VideoSection: React.FC<VideoSectionProps> = ({
    videoSrc,
    videoPoster,
    videoTitle,
    videoDescription,
    credits,
    videoPosition,
    backgroundColor,
}) => {
    return (
        <SectionWrapper $backgroundColor={backgroundColor}>
            <SectionContainer>
                <VideoSide $position={videoPosition}>
                    <VideoWrapper>
                        <VideoPlayer src={videoSrc} poster={videoPoster} />
                    </VideoWrapper>
                </VideoSide>
                <InfoSide $position={videoPosition}>
                    <InfoWrapper>
                        <VideoInfo
                            title={videoTitle}
                            description={videoDescription}
                            credits={credits}
                        />
                    </InfoWrapper>
                </InfoSide>
            </SectionContainer>
        </SectionWrapper>
    );
};
